import SensitiveInput from '@/components/SensitiveInput/index.vue';
import SensitiveAttachments from '@/components/SensitiveAttachments/index.vue';
import { searchSiteIdList } from '@/api/lanshou';
import { TYPY_OBJ } from '@/enums/customerEnums';
import { imgTypeArr, pdfTypeArr } from '@/enums/evaluateEnums';
import { mapState } from 'vuex';
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import md5 from 'js-md5';
import { checkCNPJ, checkNumber, ieNumber } from '@/utils/validate';
import methods1 from './CustomersCmp.methods1.js';
import methods2 from './CustomersCmp.methods2.js';
export default {
  components: { SensitiveInput, SensitiveAttachments },
  props: {
    ids: {
      type: [String, Number],
      default: ''
    },

    customerType: {
      type: Object,
      default() {
        return {
          id: '',
          type: 'add'
        };
      }
    }
  },
  computed: {
    ...mapState({ managerList: state => state.user.managerList }),
    sensitiveIdentity() { return `${this.$store.getters.id || ''}:${this.$store.getters.token || ''}`; },
    canEditSensitive() { return (this.$store.getters.button_permissions || []).includes('field:customer-sensitive-info'); }
  },
  data() {
    /**
     * 账户名校验
     * 防止出现重复用户名
     */
    const usernameCheck = (rule, value, callback) => {
      if (this.disabled) return callback();
      if (!value.length) {
        return callback(new Error(this.$t('customerManagements.accountNameNotEmpty'))); // '账户名称不能为空'
      }

      // 过滤空格并转换为小写
      const processedValue = value.replace(/\s/g, '').toLowerCase();
      // 检查长度限制（不超过30字符）
      if (processedValue.length > 30) {
        return callback(new Error(this.$t('customerManagements.accountNameMaxLength'))); // '账户名长度不能超过30个字符'
      }
      // 检测特殊语种字母（如葡萄牙字母：á, à, â, ã, ç, é, ê, í, ó, ô, õ, ú, ü 等）
      const specialCharRegex = /[^\x00-\x7F]/; // 匹配非 ASCII 字符
      if (specialCharRegex.test(processedValue)) {
        return callback(new Error(this.$t('customerManagements.accountNameContainsSpecialChars')));
      }
      // 检查只包含字母、数字和连接线
      const validPattern = /^[a-z0-9\-_]+$/;
      if (!validPattern.test(processedValue)) {
        return callback(new Error(this.$t('customerManagements.accountNameAllowedChars'))); // '账户名只能包含字母、数字和连接线(-_)'
      }
      this.ruleForm.username = processedValue;

      if (this.ruleForm.id) {
        return callback();
      }
      callback();
    };

    // 密码后台暂时不做限制，只有前端校验
    const passwordCheck = (rule, value, callback) => {
      if (!value.length) {
        return callback(new Error(this.$t('customerManagements.notNull'))); // '密码不能为空'
      }
      // const reg = /^[\w]{8,12}$/;
      const reg = /(?=.*[0-9].*)(?=.*[A-Z].*)|(?=.*[0-9].*)(?=.*[a-z].*).{8,12}$/;
      if (!reg.test(value)) {
        return callback(new Error(this.$t('customerManagements.input8to12SumCode'))); // '请输入8-12位数字和英文组合'
      }
      this.pwd = md5(md5(value));
      callback();
    };
    // 包裹误差
    const priceType = (rule, value, callback) => {
      const reg = new RegExp(
        '(^[1-9]\\d*(\\.\\d{1,' + rule.suffix + '})?$)|(^0(\\.\\d{1,' + rule.suffix + '})?$)'
      );
      const { required } = rule;
      if (!required) {
        // 非必填
        if (value) {
          if (!reg.test(value)) {
            this.adopt = false;
            return callback(new Error(this.$t('customerManagements.IncorrectFormatting'))); // 格式不正确
          } else {
            this.adopt = true;
            return callback();
          }
        } else {
          return callback();
        }
      } else {
        if (value) {
          if (!reg.test(value)) {
            this.adopt = false;
            return callback(new Error(this.$t('customerManagements.IncorrectFormatting'))); // '格式不正确'
          } else {
            this.adopt = true;
            return callback();
          }
        } else {
          this.adopt = false;
          return callback(this.$t('customerManagements.notNull')); // '不能为空'
        }
      }
    };
    return {
      StateList: [],
      cityList: [],
      pwd: '', // 加密的密码
      disabled: false, // 是否禁用
      readonly: false, // 仅在查看时使用
      ruleForm: {
        id: '',
        source: 'corporation', // corporation:企业，person:个人
        customerAlias: '', // 账户别称
        company: '', // 公司名称
        coPrincipalName: '', // 企业负责人名字
        coPrincipalPhone: '', // 企业负责人手机电话
        coPrincipalTel: '', // 企业负责人电话
        coPrincipalEmail: '', // 企业负责人邮箱
        packageDeviation: '', // 包裹误差
        coPrincipalQq: '', // 企业负责人QQ
        address: '', // 公司(个人)地址
        identityCard: '', // 营业执照或身份证号 '9144030059073074XQ'
        identityCardAttachment: '', // 证件照附件
        logisticsContactsName: '', // 物流联系人名字
        logisticsContactsPhone: '', // 物流联系人手机
        logisticsContactsTel: '', // 物流联系人电话
        logisticsContactsEmail: '', // 物流联系人邮箱
        logisticsContactsQq: '', // 物流联系人QQ
        password: '', // 密码
        auditState: 0, // 账户审核，0：未审核，1：已审核
        lockState: 1, // 账号锁定，0：正常，1：锁定
        integral: '0', // 积分
        handlerIdList: [], // 经办人id
        username: '', // 账户名称
        code: '', // 客户编号
        siteId: '', // 站点
        customerPhone: '', // 客户手机
        customerEmail: '', // 客户邮箱
        orderNumberType: '',
        cnpjMother: '',
        cnpjSon: '',
        ieNumber: '',
        zipcode: '',
        houseNumber: '',
        complement: '',
        street: '',
        city: '',
        state: '',
        coPrincipalIdentityCard: '',
        productRequirement: '',
        channel: '',
        level: '',
        parentId: '',
        customerSource: '',
        fulfillmentMode: ''
      },
      siteIdList: [], // 站点list
      rules: {
        cnpjMother: [
          {
            required: true,
            message: this.$t('customerManagements.inputFormat'),
            trigger: ['blur', 'change']
          },
          { validator: checkCNPJ, trigger: ['blur', 'change'] }
        ],
        packageDeviation: [
          { required: false, suffix: 3, validator: priceType, trigger: ['blur', 'change'] }
        ],
        // '请选择站点'
        siteId: [
          {
            required: true,
            message: this.$t('customerManagements.pleaseCheckSite'),
            trigger: ['blur', 'change']
          }
        ],
        level: [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: ['blur', 'change']
          }
        ],
        customerSource: [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: ['blur', 'change']
          }
        ],
        fulfillmentMode: [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: ['blur', 'change']
          }
        ],
        parentId: [
          {
            required: false,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: ['blur', 'change']
          }
        ],
        customerPhone: [
          {
            required: true,
            message: this.$t('customerManagements.maxInput20Chars'),
            max: 20,
            trigger: ['blur', 'change']
          }
        ],
        coPrincipalName: [
          {
            required: true,
            message: this.$t('customerManagements.pleaseInput'),
            trigger: ['blur', 'change']
          }
        ],
        customerEmail: [
          {
            required: true,
            message: this.$t('customerManagements.pleaseInput'),
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                return callback(new Error(this.$t('customerManagements.enterValidCustomerEmail')));
              } else {
                callback();
              }
            }
          }
        ],
        password: [{ required: true, validator: passwordCheck, trigger: ['blur', 'change'] }],
        username: [
          { required: !this.disabled, validator: usernameCheck, trigger: ['blur', 'change'] }
        ],
        customerAlias: [
          {
            required: true,
            message: this.$t('customerManagements.pleaseInput'),
            trigger: ['blur', 'change']
          }
        ],
        ieNumber: [{ required: true, validator: ieNumber, trigger: ['blur', 'change'] }],
        houseNumber: [
          {
            required: true,
            message: this.$t('GlobalSetObj.maxInput10Chars'),
            max: 10,
            trigger: ['blur', 'change']
          }
        ],
        complement: [
          {
            required: false,
            message: this.$t('GlobalSetObj.maxInput50Chars'),
            max: 50,
            trigger: ['blur', 'change']
          }
        ],
        address: [
          {
            required: true,
            message: this.$t('GlobalSetObj.maxInput100Chars'),
            max: 100,
            trigger: ['blur', 'change']
          }
        ],
        source: [{ required: true }],
        street: [
          {
            required: true,
            message: this.$t('GlobalSetObj.maxInput50Chars'),
            max: 50,
            trigger: ['blur', 'change']
          }
        ],
        zipcode: [
          { required: true, validator: checkNumber, trigger: ['blur', 'change'] },
          {
            min: 8,
            message: this.$t('mdfeTranslate.tip8Number'),
            trigger: ['blur', 'change']
          }
        ]
      },
      acceptStr: '', // 上传附件类型
      sensitiveReady: false,
      sensitiveVersion: 0,
      sensitiveError: '',
      fileList: [], // 上传
      imgFileList: [], // 图片
      PDFFileList: [], // PDF
      typeObj: TYPY_OBJ, // 当前状态
      dialog: {
        examineVisible: false,
        lockVisible: false,
        obj: {
          idList: [],
          // type: 1, // 状态类型: 1:账号锁定状态，2.账户审核状态
          value: 0
        }
      },
      // 用户列表
      userList: [],
      activeNames: ['1', '2'],
      channelList: [],
      parentAccountList: [],
      customerTypeSee: {
        id: '',
        type: 'add'
      },
      syncSenderAddress: false,
      resCusList: [],
      resModeList: []
    };
  },
  watch: {
    customerType: { deep: true, handler(value) { this.customerTypeSee = { ...value }; } },
    sensitiveIdentity: 'clearSensitiveForm',
    canEditSensitive: 'clearSensitiveForm',
    customerTypeSee: {
      handler(newVal) {
        this.clearSensitiveForm();
        // console.log('传进来的数据', newVal.type);
        if (newVal.type === 'edit' || newVal.type === 'examine' || newVal.type === 'set') {
          this.disabled = true;
          this.activeNames = ['1', '2'];
        } else {
          this.disabled = false;
        }
        if (newVal.type === 'add') {
          this.disabled = false;
          this.fileList = []; // 清空文件列表
          this.activeNames = ['1', '2', '3', '4', '5', '6'];
        }
        if (newVal.type === 'examine') {
          // readonly="true" 仅在查看时有效
          this.readonly = true;
          this.activeNames = ['1', '2'];
        } else {
          this.readonly = false;
        }
        if (newVal.type === TYPY_OBJ.add.code) {
          // 新增
          return;
        }
        this.ruleForm.id = newVal.id;
        this.getCustomerData(newVal.id);
      },
      immediate: true,
      deep: true
    }
  },
  beforeDestroy() { this.clearSensitiveForm(); },
  deactivated() { this.clearSensitiveForm(); },

  created() {
    this.customerTypeSee = { ...this.customerType };
    this.acceptStr = [...imgTypeArr, ...pdfTypeArr].join(',');
    this.userList = Object.entries(getUserIdAndNameObj()).map((item) => {
      const obj = {
        label: item[1],
        value: Number(item[0])
      };
      return Object.freeze(obj);
    });
    searchSiteIdList().then((res) => {
      if (res.code === 200) {
        res.data.forEach((data) => {
          this.siteIdList.push({ id: data.id, name: data.name });
        });
      }
    });
    this.getAddress();
    this.getChannel();
    this.getRecordField();
  },

  methods: { ...methods1, ...methods2 }
};
